/** Orders episode documents by catalog id; every document is listed exactly once and handles are unique. */
export function loadEpisodeCatalog<TEpisode extends { handle: string }>(
    space: string, ids: readonly string[], documents: ReadonlyMap<string, unknown>, parse: (value: unknown) => TEpisode,
): readonly TEpisode[] {
    if (new Set(ids).size !== ids.length || ids.length !== documents.size) {
        throw new Error(`${space} episode catalog must list every document exactly once.`);
    }
    const episodes = ids.map((id) => {
        if (!documents.has(id)) throw new Error(`Missing ${space} episode document '${id}'.`);
        return parse(documents.get(id));
    });
    if (new Set(episodes.map((episode) => episode.handle)).size !== episodes.length) {
        throw new Error(`${space} episode handles must be unique.`);
    }
    return episodes;
}
